import { useApp } from 'context/AppContext';
import React from 'react';

const IntegratedIframe = ({ src, width, height }) => {
    const { heightScreen } = useApp();

    return (
        <iframe
            src={src}
            height={height?? 800}
            title="viewPdf"
            width={width ?? heightScreen - 100}
            loading="lazy"
            frameBorder="0"
            allow="accelerometer autoplay encrypted-media gyroscope picture-in-picture"
            allowFullScreen
        ></iframe>
    );
};

export default IntegratedIframe;
